export default __webpack_public_path__ + "459ca94dac3e52fb4ba82c8ece10bedd.png";